import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { invoiceFormDefault } from "@factory/form/form.default";
import { InvoiceFormRule, InvoiceFormSchema } from "@factory/form/form.rule";
import { useQyCreateInvoice } from "@factory/query/invoice.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewInvoice() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateInvoice } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Invoice is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addInvoice, isLoading: isCreating } =
    useQyCreateInvoice(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<InvoiceFormSchema>({
    defaultValues: invoiceFormDefault,
    resolver: zodResolver(InvoiceFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: InvoiceFormSchema) => {
    const formData = mapCreateInvoice(form);
    addInvoice(formData);
  };
  const handleValidateError = (err: FieldErrors<InvoiceFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
